import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _typeof from "/data/devops/workspace/node_modules/@babel/runtime/helpers/esm/typeof";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Watch, Prop, Mixins } from 'vue-property-decorator';
import TransportOrderListMixins from './mixins/listMixins';
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';
import TableRowTip from '@/components/tableRowTip/index.vue';
import PrintSettingModal from '../list/printSettingModal/index.vue';
import util from '@/utils/util';
import { checkingPrinter } from '@/utils/printer';
var printSettingModalCom = util.mountVueComponent(PrintSettingModal);

var HistoryTransportOrderListPage = function (_super) {
  __extends(HistoryTransportOrderListPage, _super);

  function HistoryTransportOrderListPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.timeValue = _this.$util.getDefaultTimeCondition(_this.$enum.common.TimePeriodEnum.THREE_MONTH);
    return _this;
  }

  Object.defineProperty(HistoryTransportOrderListPage.prototype, "statusList", {
    get: function get() {
      return this.$util.mergeCountDataToStatusEnum(this.orderStatusEnum, this.statusCountList, {
        text: this.t('全部'),
        value: String(this.$enum.common.StatusEnum.ALL),
        total: 0
      });
    },
    enumerable: false,
    configurable: true
  });

  HistoryTransportOrderListPage.prototype.onTimeValueChange = function (dateRange) {
    if (dateRange.length === 2) {
      this.searchData.start_time = this.$util.formatDateTime(dateRange[0]);
      this.searchData.end_time = this.$util.formatDateTime(dateRange[1]);
    } else {
      this.searchData.start_time = '';
      this.searchData.end_time = '';
    }
  };

  HistoryTransportOrderListPage.prototype.handleCancel = function (record) {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        this.$confirm({
          title: this.tc('温馨提示'),
          content: this.t('请确认是否取消该订单？'),
          onOk: function onOk() {
            var _a;

            _this.cancelOrderOperation([record.shipper_hawbcode], (_a = {}, _a[record.shipper_hawbcode] = record.order_id, _a));
          }
        });
        return [2];
      });
    });
  };

  HistoryTransportOrderListPage.prototype.handleCancelBulk = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        if (!this.selectedList.length) {
          this.$message.warn(this.t('请选择取消的订单'));
          return [2];
        }

        this.$confirm({
          title: this.tc('温馨提示'),
          content: this.t('请确认是否取消已选订单？'),
          onOk: function onOk() {
            var dataMap = _this.createShipCodeDataMap(_this.selectedList);

            _this.cancelOrderOperation(_this.selectedList, dataMap);
          }
        });
        return [2];
      });
    });
  };

  HistoryTransportOrderListPage.prototype.handleSearch = function () {
    this.searchData.page_index = 1;
    this.searchData.hawb_codes = this.docValue ? this.docValue.split(',') : [];
    this.getList();
  };

  HistoryTransportOrderListPage.prototype.handleReset = function () {
    this.searchData = this.initSearchData();
    this.searchData.order_status = String(this.$enum.common.StatusEnum.ALL);
    this.timeValue = this.$util.getDefaultTimeCondition(this.$enum.common.TimePeriodEnum.THREE_MONTH);
    this.docValue = '';
    this.getList();
  };

  HistoryTransportOrderListPage.prototype.handleOrderStatusChange = function () {
    this.getList();
  };

  HistoryTransportOrderListPage.prototype.handleExportAll = function () {
    var params = this.$util.deepCopy(this.searchParam);
    delete params.page_index;
    delete params.page_size;
    this.exportList(params);
  };

  HistoryTransportOrderListPage.prototype.handleExportSelected = function () {
    if (!this.selectedList.length) {
      this.$message.warn(this.tc(this.$config.exportSelectedEmptyTip));
      return;
    }

    this.exportList({
      order_type: this.$enum.historyTransportOrder.OrderTypeEnum.SHIPPER,
      hawb_codes: this.selectedList
    });
  };

  HistoryTransportOrderListPage.prototype.handlePrintLabelBulk = function () {
    return __awaiter(this, void 0, void 0, function () {
      var list, _loop_1, this_1, i, state_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.selectedList.length) {
              this.$message.warn(this.tc(this.$config.exportSelectedEmptyTip));
              return [2];
            }

            return [4, checkingPrinter()];

          case 1:
            if (!_a.sent()) {
              return [2];
            }

            return [4, this.queryPrintSetting()];

          case 2:
            _a.sent();

            list = this.listData.filter(function (item) {
              return _this.selectedList.indexOf(item.shipper_hawbcode) > -1;
            });

            _loop_1 = function _loop_1(i) {
              var item;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    item = this_1.printSettingList.find(function (item) {
                      return item.product_code === list[i].product_code;
                    });

                    if (!item || item && this_1.$util.isEmpty(item.print_index)) {
                      this_1.$message.warn(this_1.t('物流产品{0}未配置打印设置', [list[i].product_code]));
                      return [2, {
                        value: void 0
                      }];
                    }

                    return [4, this_1.execPrintLabel(list[i], item)];

                  case 1:
                    _a.sent();

                    return [2];
                }
              });
            };

            this_1 = this;
            i = 0;
            _a.label = 3;

          case 3:
            if (!(i < list.length)) return [3, 6];
            return [5, _loop_1(i)];

          case 4:
            state_1 = _a.sent();
            if (_typeof(state_1) === "object") return [2, state_1.value];
            _a.label = 5;

          case 5:
            i++;
            return [3, 3];

          case 6:
            return [2];
        }
      });
    });
  };

  HistoryTransportOrderListPage.prototype.handlePrintLabel = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var item;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.queryPrintSetting()];

          case 1:
            _a.sent();

            item = this.printSettingList.find(function (item) {
              return item.product_code === data.product_code;
            });

            if (!item || item && this.$util.isEmpty(item.print_index)) {
              this.$message.warn(this.t('物流产品{0}未配置打印设置', [data.product_code]));
              return [2];
            }

            return [4, this.execPrintLabel(data, item)];

          case 2:
            _a.sent();

            return [2];
        }
      });
    });
  };

  HistoryTransportOrderListPage.prototype.handleBulkFeedback = function (bulkKeywords) {
    this.docValue = bulkKeywords;
  };

  HistoryTransportOrderListPage.prototype.handlePrintSetting = function () {
    printSettingModalCom({
      parent: this,
      propsData: {
        isHistory: this.$enum.common.Enabled.YES
      }
    });
  };

  HistoryTransportOrderListPage.prototype.handleDblClick = function () {
    var bulkSearchRef = this.$refs.bulkSearchModal;
    bulkSearchRef.modalVisible = true;
    bulkSearchRef.bulkListStr = this.docValue;
  };

  HistoryTransportOrderListPage.prototype.handlePageChange = function (page, pageSize) {
    if (page > this.searchData.page_index) {
      this.searchData.page_token = this.searchData.next_token;
    } else if (page < this.searchData.page_index) {
      this.searchData.page_token = this.searchData.prev_token;
    } else {
      delete this.searchData.page_token;
    }

    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.getList();
  };

  HistoryTransportOrderListPage.prototype.handlePrintCertificateBulk = function () {
    if (!this.selectedList.length) {
      this.$message.warn(this.t('请选择需要打印发货证明的单据'));
      return;
    }

    this.downloadShippingCertification({
      order_code_list: this.selectedList
    });
  };

  HistoryTransportOrderListPage.prototype.handlePrintCertificate = function (record) {
    this.downloadShippingCertification({
      order_code_list: [record.shipper_hawbcode]
    });
  };

  HistoryTransportOrderListPage.prototype.created = function () {
    var _this = this;

    this.initColumns();
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys, selectedRow) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
      }
    };
    this.queryWarehouseList();
    this.queryCountryList();
    this.queryLogisticsList();
    this.queryPrintSetting();
    this.getList();
  };

  __decorate([Prop({
    type: Number,
    "default": 1
  })], HistoryTransportOrderListPage.prototype, "status", void 0);

  __decorate([Watch('timeValue', {
    immediate: true
  })], HistoryTransportOrderListPage.prototype, "onTimeValueChange", null);

  HistoryTransportOrderListPage = __decorate([Component({
    components: {
      BulkSearchModal: BulkSearchModal,
      TableRowTip: TableRowTip
    }
  })], HistoryTransportOrderListPage);
  return HistoryTransportOrderListPage;
}(Mixins(TransportOrderListMixins));

export default HistoryTransportOrderListPage;